import React from 'react'
import styled from 'styled-components'

type IProps = {
	flow?: '<-' | '->' | '<-|->' | '>-|-<';
	width?: string;
	children?: React.ReactNode | (React.ReactNode | null)[] | null;
}

const Panel = styled.div`
	box-sizing: border-box;
	display: flex;
	gap: 12px;
	&[data-flow="<-|->"] {
		justify-content: center;
	}
  &[data-flow=">-|-<"] {
      justify-content: space-between;
  }	
	&[data-flow="->"] {
		justify-content: start;
	}
	&[data-flow="<-"] {
		justify-content: end;
	}
	padding: 6px 12px;
`
export const ToolPanel = (props: IProps) => {
	// TODO: check
	// ATTENTION: do NOT remove now className={'bg-white'} because
	// it is a temp fix of unclear extra side effects onFiltersButtonIconHover && custom .scroll
	// like inherited grey bg or duplicated/not existed table mark-up
	return <Panel data-flow={props.flow ?? '->'}
	              style={{width : props.width ?? 'auto'}}
	              className={'bg-white'}
	>
		{props.children}
	</Panel>
}
